import apiClient from "../clients/apiClient";
import { ApiResponse } from "../schemas/apiResponseSchema";

export interface CustomerGroupResponse {
    id: number;
    group_name: string;
    group_description?: string | null;
    active: boolean;
}

export const getAllCustomerGroups = async (): Promise<CustomerGroupResponse[]> => {
    try {
        const response: ApiResponse<CustomerGroupResponse[] | null> = (
            await apiClient.get("/pos_customer_group/all", {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        return response.data || [];
    } catch (error: any) {
        if (error?.response?.status === 401) {
            throw new Error("Not authorized to load customer groups. Please sign in with backend authentication.");
        }

        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }

        throw new Error("Failed to fetch customer groups");
    }
};
